<template>
  <div class="pro-wrapper">
    <span>
      <i class="fa fa-lg" :class="[iconClass]" aria-hidden="true"></i>
    </span>
    <div class="info">
      <h4>{{title}}</h4>
      <p>
        <small>{{text}}</small>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pro',
  props: [
    'iconClass',
    'title',
    'text',
  ],
};
</script>

<style lang="scss" scoped>
  .pro-wrapper {
    display: flex;
    justify-content: center;

    span {
      font-size: 1.5rem;
      margin: 0 1rem;
      // width: 30%;

      i {
        width: 2rem;

        &.text-red {
          color: #f44336;
        }

        &.text-blue {
          color: #3F51B5;
        }

        &.text-green {
          color: #4CAF50;
        }
      }
    }

    .info {
      p {
        max-width: 20rem;
      }

    }
  }
</style>




// WEBPACK FOOTER //
// src/components/home/Pro.vue